import React, { useEffect, useState } from "react";
import Reveal from "../components/Reveal";
import ServicesStrip from "../components/ServicesStrip";
import PageSeo from "../components/PageSeo";
import { fetchServices } from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { useSettings } from "../context/SiteSettingsContext";

export default function ServicesPage() {
  const { t, lang } = useLang();
  const settings = useSettings();
  const [services, setServices] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchServices().then(setServices).catch(() => {}); }, []);

  const seoTitle = lang === "en" ? settings.services_meta_title_en : settings.services_meta_title_it;
  const seoDesc = lang === "en" ? settings.services_meta_desc_en : settings.services_meta_desc_it;

  return (
    <div className="pt-32 bg-[#09090b] min-h-screen" data-testid="services-page">
      <PageSeo title={seoTitle} description={seoDesc} pathIt="/it/servizi" pathEn="/en/services" />
      <div className="container-x pb-8">
        <Reveal>
          <div className="overline mb-4">{t.services.overline}</div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1] max-w-3xl">
            {t.services.title.split("\n").map((l, i) => (<span key={l || `sp-line-${i}`} className="block">{l}</span>))}
          </h1>
          <p className="mt-6 text-white/70 max-w-xl">{t.services.subtitle}</p>
        </Reveal>
      </div>
      <ServicesStrip services={services} />
    </div>
  );
}
